import 'normalize.css';
import isMobile from './utils/isMobile';

//vconsole
// import Vconsole from 'vconsole';
// if (isMobile()) {
//   // 上线修改
//   new Vconsole();
//   localStorage.setItem('vConsole_switch_y', window.innerHeight / 2);
// }

import Vue from 'vue';

Vue.config.productionTip = false;

import './shims/firmHtmlRem';

// 修复微信滚动
import preventScroll from './utils/preventScroll';
preventScroll();

//VueBus
import VueBus from './utils/vueBus';
Vue.use(VueBus);
import { init, initTipsPage } from './config';

// 封测试链接
// document.querySelector(".tips-text").innerHTML = '非正式链接';
// initTipsPage();

window.onload = /AppleWebKit.*Mobile.*/.test(navigator.userAgent)
  ? init
  : initTipsPage;
